import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { getWhatsAppUrl } from '../utils/whatsapp';
import { Ship, MessageCircle, CheckCircle2 } from 'lucide-react';
export const HowItWorks = () => {
  const {
    t
  } = useLanguage();
  const handleWhatsApp = () => {
    const message = t('wa.help');
    window.open(getWhatsAppUrl(message), '_blank');
  };
  const steps = [{
    num: 1,
    icon: Ship,
    titleKey: 'hiw.s1.title',
    descKey: 'hiw.s1.desc'
  }, {
    num: 2,
    icon: MessageCircle,
    titleKey: 'hiw.s2.title',
    descKey: 'hiw.s2.desc'
  }, {
    num: 3,
    icon: CheckCircle2,
    titleKey: 'hiw.s3.title',
    descKey: 'hiw.s3.desc'
  }];
  return <section id="como-funciona" className="py-12 sm:py-16 md:py-20 bg-white" data-id="element-339">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-340">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy mb-10 sm:mb-16" data-id="element-341">
          {t('hiw.title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 sm:gap-12 relative" data-id="element-342">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16.66%] right-[16.66%] h-0.5 bg-gray-100 z-0" data-id="element-343"></div>

          {steps.map(step => {
          const Icon = step.icon;
          return <div key={step.num} className="relative z-10 flex flex-col items-center" data-id="element-344">
                <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-card border-4 border-white shadow-lg flex items-center justify-center mb-5 sm:mb-6 relative" data-id="element-345">
                  <Icon className="w-8 h-8 sm:w-10 sm:h-10 text-turquoise" data-id="element-346" />
                  <div className="absolute -top-2 -right-2 w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-navy text-white font-bold flex items-center justify-center text-xs sm:text-sm border-2 border-white" data-id="element-347">
                    {step.num}
                  </div>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-navy mb-2 sm:mb-3" data-id="element-348">
                  {t(step.titleKey)}
                </h3>
                <p className="text-gray-600 max-w-xs" data-id="element-349">{t(step.descKey)}</p>
              </div>;
        })}
        </div>

        <div className="mt-10 sm:mt-16" data-id="element-350">
          <button onClick={handleWhatsApp} className="bg-turquoise hover:bg-turquoise-dark text-navy font-bold py-4 px-10 rounded-full transition-all transform hover:scale-105 flex items-center justify-center space-x-2 mx-auto uppercase tracking-wide text-sm shadow-lg shadow-turquoise/30" data-id="element-351">
            <MessageCircle className="w-5 h-5" data-id="element-352" />
            <span data-id="element-353">{t('hiw.cta')}</span>
          </button>
        </div>
      </div>
    </section>;
};